<div
  class="modal fade"
  [class.show]="isVisible"
  [style.display]="isVisible ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmationPopupLabel"
  [attr.aria-hidden]="!isVisible"
  [attr.aria-modal]="isVisible"
>
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 420px">
    <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
      <div class="modal-header bg-primary text-white p-4">
        <h5 class="modal-title" id="confirmationPopupLabel">{{ title }}</h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="cancel()"></button>
      </div>
      <div class="modal-body px-4 py-3 text-muted">
        <p class="fs-6 mb-0">{{ message }}</p>
      </div>
      <div class="modal-footer bg-light border-0 justify-content-between px-4 py-3">
        <button
          type="button"
          class="btn {{ cancelButtonClass }} text-uppercase"
          (click)="cancel()"
        >
          {{ cancelButtonText }}
        </button>
        <button
          type="button"
          class="btn {{ confirmButtonClass }} text-uppercase"
          (click)="confirm()"
        >
          {{ confirmButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isVisible" class="modal-backdrop fade show"></div>
